import React from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";
import { useDialog, GLOBAL_DIALOG_ID } from "@/hook";
import Button from "@/component/Button";
import { Modal } from ".";


const Dialog: React.FC = () => {
    const dialog = useDialog();
    const intl = useIntl();

    const onClickCancel = () => {
        dialog.data?.onCancel?.();
        dialog.close();
    };

    const onClickConfirm = () => {
        dialog.data?.onConfirm?.();
        dialog.close();
    };

    return (
        <Modal id={GLOBAL_DIALOG_ID}
               size={dialog.data?.size || "sm"}
               title={
                   <div className="modal-header">
                       {dialog.data?.title}
                   </div>
               }
        >
            <div className="flex flex-col gap-5">
                {dialog.data?.content &&
                    <div className={classNames(
                             "modal-description whitespace-pre-wrap",
                             dialog.data?.title && "mt-5"
                         )}
                    >
                        {dialog.data.content}
                    </div>
                }

                <div className="modal-btn-group">
                    {!dialog.data?.hideCancel && (
                        <Button variant="secondary"
                                size="sm"
                                onClick={onClickCancel}
                        >
                            {dialog.data?.cancelText ?? intl.formatMessage({ id: "b0002" })}
                        </Button>
                    )}
                    <Button variant={dialog.data?.variant ?? "primary"}
                            size="sm"
                            onClick={onClickConfirm}
                    >
                        {dialog.data?.confirmText ?? intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default Dialog;
